import { render } from "./section_4.vue?vue&type=template&id=7ef73ad1"
import script from "./section_4.vue?vue&type=script&lang=js"
export * from "./section_4.vue?vue&type=script&lang=js"

import "./section_4.vue?vue&type=style&index=0&id=7ef73ad1&lang=css"
script.render = render

export default script